// Types
import { UnitAndRangeState } from './unitAndRangeStore.types';

// Initial state for the unit and range filter
export const initialState: UnitAndRangeState = {
  minValue: undefined,
  maxValue: undefined,
  range: [undefined, undefined],
  options: [],
  hasRangePill: false,
  unit: 'All',
};
